<template>
<v-card flat class="pa-3">
    <v-card-text>
        <v-row no-gutters>
            <v-col cols="12" md="4">
                <div class="important">
                    Place
                </div>
                <div class="regular" v-if="item.place">
                    {{ item.place.name }}
                </div>
                <div v-else>
                    No city assign
                </div>
            </v-col>

            <v-col cols="12" md="4">
                <div class="important">
                    Section
                </div>
                <div class="regular" v-if="item.section">
                    {{ item.section.name }}
                </div>
                <div v-else>
                    No section assign
                </div>
            </v-col>

            <v-col cols="12" md="4">
                <div class="important">
                    Language
                </div>
                <div class="regular">
                    {{ item.language }}
                </div>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row no-gutters>
            <v-col cols="12">
                <div class="regular-title mb-2">
                    {{ item.title }}
                </div>
            </v-col>

            <v-col cols="12">
                <div class="regular-content" v-html="item.body">
                </div>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row no-gutters>
            <v-col cols="6">
                <div class="important">
                    Order
                </div>
                <div class="regular">
                    {{ item.order }}
                </div>
            </v-col>

            <v-col cols="6">
                <div class="important">
                    Status
                </div>
                <div class="regular">
                    {{ item.status }}
                </div>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row no-gutters>
            <v-col cols="3" v-for="(photo, index) in photos" :key="index" class="pa-2 text-xs-center">
                <div style="position: relative">
                    <v-img :src="photo.url" height="200" cover />
                </div>
            </v-col>
        </v-row>

    </v-card-text>

</v-card>
</template>

<script>
import defaults from "../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.article_item
        }
    },
    data() {
        return {
            photos: []
        }
    },
    watch: {
        'item.id': {
            handler() {
                this.photos = [];
                this.getPhotos();
            }
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },

        getPhotos() {
            // this.loading = true;
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            // setup query params
            let params = {
                params: {
                    article_ids: [this.item.id],
                    stamp: stamp
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.photos = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    // this.loading = false;
                });
        },
    },

}
</script>

<style>
.regular-title {
    font-size: 30px;
    font-weight: 700;
    font-family: Open Sans, sans-serif;
}

.regular-content {
    font-size: 21px;
    font-weight: 400;
    font-family: Lora, serif;
    line-height: 1.58;
}
</style>
